import { useState, useEffect } from 'react';
import MetallicPaint, { parseLogoImage } from "./MetallicPaint";
import './App.css';

import logo from './icon.svg';

function App() {
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    async function loadDefaultImage() {
      try {
        const response = await fetch(logo);
        const blob = await response.blob();
        const file = new File([blob], "icon.svg", { type: blob.type });
        const parsedData = await parseLogoImage(file);
        setImageData(parsedData?.imageData ?? null);
      } catch (err) {
        console.error("Error loading default image:", err);
      }
    }
    loadDefaultImage();
  }, []);

  return (
    <div style={{ 
      width: '100vw',
      height: '100vh',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      margin: 0,
      overflow: 'hidden',
      boxSizing: 'border-box'
    }}>
      {imageData && (
        <div style={{ 
          width: '100%', 
          maxWidth: '600px',
          aspectRatio: '1/1'
        }}>
          <MetallicPaint 
            imageData={imageData} 
            params={{ 
              edge: 0.15, 
              patternBlur: 0.003, 
              patternScale: 1.05, 
              refraction: 0.014, 
              speed: 0.2, 
              liquid: 0.3 
            }} 
          />
        </div>
      )}
    </div>
  );
}

export default App;